import {
    Component,
    EventEmitter,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { GridToolComponent } from '../grid-toolbar-component/grid-tool.component';

@Component({
    selector: 'app-clear-filters',
    imports: [MatIconModule, MatButton],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './clear-filters.component.html',
})
export class ClearFiltersComponent extends GridToolComponent {
    @Output() cleared = new EventEmitter<void>();

    clearFilters() {
        this.gridApi?.setFilterModel(null);
        this.gridApi?.setGridOption('quickFilterText', '');
        this.cleared.emit();
    }
}
